import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { DataTablesResponse } from '../../shared/models/datatables-response';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { OpportunityOfferOutputModel } from '../../shared/models/OpportunityOfferOutputModel';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { INoteInput } from '../../shared/models/NotesInputModel';
import { Router } from '@angular/router';
import { ValidationService } from '../../shared/providers/validation.service';
import { LoaderService } from '../../shared/providers/loader.service';
import { PropertyManagementService } from '../../shared/providers/property-management.service';
import { ToastService } from '../../shared/providers/toast.service';
import { OfferService } from '../../shared/providers/offer.service';

@Component({
  selector: 'app-deals-list-buy',
  templateUrl: './deals-list-buy.component.html',
  styleUrls: ['./deals-list-buy.component.css']
})
export class DealsListBuyComponent implements OnInit {

  constructor(private http: HttpClient, public Authentication: AuthenticationService, private modalService: BsModalService, private router: Router, public Validation: ValidationService,
    private _loader: LoaderService, private _propertyManagerService: PropertyManagementService, private _toastService: ToastService, private offerService: OfferService
  ) { }
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  dtOptions = {};
  protected readonly BASE_URL: string = environment.base_url;
  offers: OpportunityOfferOutputModel[];
  modalBuyerRef: BsModalRef;
  user: any;
  isBroker = false;
  pageName = "My Offers";
  selectedOfferId: number;
  selectedTab = 1;
  selectedSubTab = 1;
  BuyerQuestionsOfferId: number = 0;
  BuyerQuestionsPropertyId: number = 0;
  IsLoading = false;
  ngOnInit() {
    this.user = this.Authentication.user;
    this.isBroker = this.Authentication.Broker();
    let TableColums = [
      { data: 'OfferDate' },
      { data: 'OfferDate' },
      { data: 'NotAnsweredQustionsCount' },
      { data: 'TenantName' },
      { data: 'PrimaryContactName' },
      { data: 'LeadName' },
      { data: 'Price' },
      { data: 'OfferPrice' },
      { data: 'EarnestMoneyDeposit' },
      { data: 'DueDiligencePeriod' },
      { data: 'ClosingPeriod' },
      { data: 'Comments' },
      { data: 'StatusName' }
    ];

    if (this.isBroker) {
      this.pageName = "Offers";
    }
    if (this.Authentication.IsUserRole(this.Authentication.UserRole.Principal) || this.Authentication.IsUserRole(this.Authentication.UserRole.Principal1031) || this.Authentication.IsUserRole(this.Authentication.UserRole.ExternalBroker) || this.Authentication.IsUserRole(this.Authentication.UserRole.Broker)) {
      TableColums = [
        { data: 'OfferDate' },
        { data: 'OfferDate' },
        { data: 'NotAnsweredQustionsCount' },
        { data: 'TenantName' },
        { data: 'PrimaryContactName' },
        { data: 'LeadName' },
        { data: 'Price' },
        { data: 'OfferPrice' },
        { data: 'EarnestMoneyDeposit' },
        { data: 'DueDiligencePeriod' },
        { data: 'ClosingPeriod' },
        { data: 'Comments' },
        { data: 'StatusName' }];
    }
    const that = this;
    this.dtOptions = {
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      info: false,
      language: {
        zeroRecords: null,
        processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
      },
      "pageLength": 50,
      "order": [[0, "desc"]],
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        this.IsLoading = true;
        const filter =
        {
          IsBuy: true,
          IsArchive: this.isArchive
        }
        dataTablesParameters.Extra_param = filter;
        const httpHeader = this.Validation.GetAuthHeader();
        that.http
          .post<DataTablesResponse>(
            this.BASE_URL + '/opportunity/principalOffers/' + this.user.Id + '/' + this.user.Id,
            dataTablesParameters, httpHeader
          ).subscribe(resp => {
            that.offers = resp.data ? resp.data : [];

            if (resp.data.length === 0) {
              $(".dataTables_paginate.paging_full_numbers").hide()
            }
            if (resp) {
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
            } else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
            }
            $(".paginate_button.first,.paginate_button.last").hide();
            this.IsLoading = false;
          });
      },
      columnDefs: [
        { orderable: false, targets: 0 }
      ],
      columns: TableColums
    };
  }
  isSubmit = false;
  fromPage: string = this.router.url;
  modalRef: BsModalRef;
  NotesInput = {} as INoteInput;
  openModalForNotes(template: TemplateRef<any>, classes, objectId, offer) {
    offer.UnReadNoteCount = 0;
    this.isSubmit = false;

    this.NotesInput.Id = 0;
    this.NotesInput.Description = '';
    this.NotesInput.UserId = this.user.Id;

    this.NotesInput.ObjectId = objectId;
    this.NotesInput.ObjectTypeId = 303;
    this.modalRef = this.modalService.show(template, { class: classes });
  }
  closeModal() {
    this.modalRef.hide();

  }

  onHomeBreadCrumbClick() {
    this.router.navigateByUrl('/principal-dashboard');
  }

  onSearch(text: string) {
    this.dtElement.dtInstance.then(x => x.search(text).draw());
  }

  switchTab(val) {
    this.selectedTab = val;
  }

  isArchive: boolean = false;
  ArchiveTab(val) {
    this.selectedSubTab = val;
    this.isArchive = val == 1 ? false : true;
    this.dtElement.dtInstance.then(x => x.draw());
  }

  openModal(template: TemplateRef<any>, classes: any, id: number, index: number) {
    this.selectedOfferId = id;
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  deleteOffers() {
    var loggedinUserId = this.user.Id;
    this._loader.display(true);
    var offerId = this.selectedOfferId;
    if (offerId > 0) {
      this._propertyManagerService.deleteOffers(offerId, loggedinUserId).subscribe(response => {
        if (response.toString() == 'true') {
          this._toastService.addToast({
            title: 'Success', msg:
              'Offer deleted successfully', timeout:
              5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
          });
        }
        else {
          this._toastService.addToast({
            title: 'Error', msg:
              'Error deleting Offer', timeout:
              5000, theme: 'bootstrap', position: 'bottom-right', type: 'error'
          });
        }
        this.dtElement.dtInstance.then(x => x.draw());
        this._loader.display(false);
      });
    }
  }
  openBuyerModal(template: TemplateRef<any>, classes: any, id: number, index: number) {
    this.BuyerQuestionsOfferId = id;
    this.BuyerQuestionsPropertyId = index;
    this.modalBuyerRef = this.modalService.show(template, { class: classes });
  };

  SendBuyerQuestionsRemainder(offerId: number) {
    this.offerService.SendBuyerQuestionsRemainder(offerId, this.user.Id).subscribe(response => {
      if (response.toString() == 'true') {
        this._toastService.addToast({
          title: 'Success', msg:
            'Reminder sent successfully', timeout:
            5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
        });
      }
      else {
        this._toastService.addToast({
          title: 'Error', msg:
            'Error occured', timeout:
            5000, theme: 'bootstrap', position: 'bottom-right', type: 'error'
        });
      }
    });
  }
}
